import { User } from "../components/users/types";
import {
  frontendSimulatedAccess,
  masqueradeToken,
  userIsFPEmployee,
} from "../util";
import { RBACAccessLevel, RBACDomain, RolePermissions } from "./types";

export const userHasAccess = (
  user: User | undefined,
  permissions: RolePermissions | undefined,
  domain: RBACDomain,
  accessLevel: RBACAccessLevel,
): boolean => {
  // While simulating restricted access, the simulated set is the only authority.
  // The Freshpaint-employee and masquerade bypass is skipped so a superuser sees
  // exactly what the simulated permissions grant. A backend-only simulation is
  // ignored here (frontendSimulatedAccess returns null), leaving the UI
  // unrestricted so the backend can be tested as the sole enforcement boundary.
  const sim = frontendSimulatedAccess();
  if (sim) {
    return (sim.permissions[domain] ?? []).includes(accessLevel);
  }

  if (userIsFPEmployee() || masqueradeToken()) {
    return true;
  }

  if (permissions === undefined) {
    return false;
  }

  if (user === undefined || user.role.length === 0) {
    return false;
  }

  if (!permissions[user.role]) {
    return false;
  }

  const rolePermissions = permissions[user.role];
  if (!rolePermissions[domain]) {
    return false;
  }

  const domainAccessLevels = rolePermissions[domain];
  return domainAccessLevels.includes(accessLevel);
};
